import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useBusinessUnit } from "../../context/BusinessUnitContext";

const InternalRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { isLoaded, isConsultantPortal, landingPath } = useBusinessUnit();

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isLoaded) return null;
  if (isConsultantPortal) return <Navigate to={landingPath} replace />;
  return children;
};

export default InternalRoute;
